import { GlobalClassInstance } from "@commoncore/constants/GlobalClass";
import { TOAST } from "@commoncore/constants/ToastMessages";
import { GlobalService } from "@commoncore/services/global.service";
import { LocalStorageSvc } from "@commoncore/services/localStorage.service";
import { ENV_CONSTANTS } from "@env-properties/environment";
import { window } from "rxjs";

export class MemoryImplementation {
    public router: any;
  public http: any;
  public route: any;
  public universalService: any;
  static singleInstance: MemoryImplementation;
  localStorageSvc: LocalStorageSvc;
  public listService:any;
  cleverTapEventsService:any;
  customMetadata: any;


  currentPage4SlideShow:number = 1;
  totalPages4SlideShow:number = 1;
  numberOfThumbnails4SlideShow: number = 10;
  
  numberOfThumbnails4SlideShowMobile: number = 5;
  allMemoriesFirstObjectUrls : any = [];
  memoriesList : any = [];
  memoryObjectsList : any = [];
  previousMemory : any;
  nextMemory : any;
  shareLink : any = "";
  previewMemoryIndex:any = -1;

  

  constructor(public globalService: GlobalService) {
    this.setHandler(globalService);
  }

  public setHandler(globalService) {
    this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.route = globalService.getActivatedRoute();
    this.localStorageSvc = globalService.getLocalStorageSvcRef();
    this.listService = globalService.getListServiceRef();
    this.cleverTapEventsService = globalService.getCleverTapEventsvc();
    this.customMetadata = globalService.getCustomMetadataServiceRef();
    
  }

  public static getInstance(globalService): MemoryImplementation {
    if (this.singleInstance == null) {
      this.singleInstance = new MemoryImplementation(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }

  updateMemoryObjectListPagination(objectList) {
    var self = this;

    var carwidth = jQuery("#carousel-inner").width() 
    if(!self.universalService.isMobileDevice && jQuery(window).width() <= 1366 ){
      var width4desktop = 125;
    }else{
      var width4desktop = 115;
    }
    var width4mobile = 55;

    if(self.universalService.isMobileDevice){
      carwidth = jQuery(window).width() -  (jQuery('.prev-carousalBtn').outerWidth() + jQuery('.next-carousalBtn').outerWidth() + 25);
      self.numberOfThumbnails4SlideShow = Math.round(carwidth/width4mobile); 
      jQuery("#carousel-inner").width(self.numberOfThumbnails4SlideShow * width4mobile);
    } else {
      self.numberOfThumbnails4SlideShow = Math.round(carwidth/width4desktop);
      jQuery("#carousel-inner").width(self.numberOfThumbnails4SlideShow * width4desktop);
    }
    self.totalPages4SlideShow = Math.ceil(objectList.length / self.numberOfThumbnails4SlideShow);
  }

  getAllMemories(url,memoryKey){
    var self = this;
    //this.resetMemoriesList();
    return new Promise(function(resolve,reject){
      self.http.get(url).subscribe(
        suc=>{
          if(memoryKey){
            var findMemory = suc["spotLights"].find(mem=>mem["spotLightKey"] == memoryKey)
            if(findMemory){
              self.universalService.currentMemory = findMemory;
            }else{ // memory key not found in user memories list
              self.universalService.showToast(TOAST["INVALID_MEMORY_KEY"],"error");
              self.router.navigate(["/home"])
            }
          }
          var memList = self.setMemoryMetadata(suc["spotLights"]);
          resolve(memList);
        },
        err=>{
          console.log("error in fetching memories",err);
          self.universalService.showLoader = false;
          reject(err);
        }
      )
    })
  }

  removeMemories(url,memoryKey){
    var self = this;
    var params = {
      "spotLightKey": memoryKey,
      "status" : "R"
    }
    return new Promise(function(resolve,reject){
      self.http.put(url,params).subscribe(
        suc=>{
          resolve({"memoryHidden":true,resp:suc});
        },
        err=>{
          console.log("error in hiding memory object",err);
          reject({"memoryHidden":false,error:err["error"]});
        }
      )
    })
  }

  hideMemoryObject(url,memoryKey,obj){
    var self = this;
    var params = {
      "spotLightKey": memoryKey,
      "objects": [{ 
        "objectKey":obj.objectKey, 
        "status" :"R" 
      }] 
    }
    return new Promise(function(resolve,reject){
      self.http.put(url,params).subscribe(
        suc=>{
          resolve({"objectHidden":true,resp:suc});
        },
        err=>{
          console.log("error in hiding memory object",err);
          reject({"objectHidden":false,error:err["error"]});
        }
      )
    })
  }

  markMemoryAsSeen(url,memory){
    var self = this;
    var payload = {
      "featureCode": "SPT",
      "cardUniqueCode": memory["spotLightKey"],
      "cardActionCode": "VIEWED"
    }
    return new Promise(function(resolve,reject){
      self.http.post(url,payload).subscribe(
        suc=>{
          self.universalService.currentMemory["isSeen"] = true;
          self.memoriesList[memory["memoryIndex"]]["isSeen"] = true;
          resolve({"markedSeen":true,resp:suc});
        },
        err=>{
          console.log("error in marking memory",err);
          reject({"markedSeen":false,error:err});
        }
      )
    })
  }



  async setMemoryMetadata(memoriesList){
    var self = this;
    var memList = [];
    memList = this.customMetadata.getCreatedDates(memoriesList);
    memList = memList.filter(mem=>(mem["objects"] && mem["objects"].length != 0));
    memList.map((mem,index)=>{
      let type = self.universalService.checkIfImgTypeParamIsRequired("");
      mem["publishedOn"] = self.setDateFormat(mem["publishedDate"]);
      // mem["thumbnailUrl"] = mem["objects"][0]["imageTranscodeUrl"];
      mem["originalThumbnailUrl"] = mem["thumbnailUrl"];
      mem["thumbnailUrl"] = mem["thumbnailUrl"]==undefined?"":(mem["thumbnailUrl"].includes('?') ? mem["thumbnailUrl"] + '&': mem["thumbnailUrl"] + '?') + "size=c&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
      // mem["thumbnailUrl"] = mem["thumbnailUrl"].split(".com")[1];
      mem["format"] = "memory";
      mem["memoryIndex"] = index;
      if (mem["objects"] && mem["objects"].length > 0) {
        mem["objects"] = this.customMetadata.segregateData(mem, "allfiles");
        mem["objects"].map(obj => {
          let type = self.universalService.checkIfImgTypeParamIsRequired(obj["mimeSubType"]);
          obj["imageTranscodeUrl"] = !this.universalService.isMobileDevice ? obj["imageTranscodeUrl"].replace("size=c", "size=b") : obj["imageTranscodeUrl"].replace("size=c", "size=a");
          obj["imageTranscodeUrl"] = obj["imageTranscodeUrl"] + type;
          // obj["imageTranscodeUrl"] = obj["imageTranscodeUrl"].split(".com")[1];
        })
        self.allMemoriesFirstObjectUrls.push(mem["objects"][0]);
      }
    })
    memList = this.customMetadata.setDefaultIconThumbnailAndIconClasses(memList);
    self.memoriesList = memList;
    return self.memoriesList;
  }

  updateIndexForMemories(){
    this.memoriesList.map((memory,index)=>{
      memory["memoryIndex"] = index;
    })
  }


  setDateFormat(utcSeconds){
    var date;
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var d = new Date(utcSeconds);
    date = d.getDate() + " " + months[d.getMonth()] + " " + d.getFullYear()
    return date
  }

  getCurrentDateTimeFormat() {
    var currentDate = new Date();
    let date = currentDate.getDate();
    let mon = this.universalService.LONG_MONTH_NAMES[currentDate.getMonth()].slice(0,3);
    let year = currentDate.getFullYear();
    let defaultCurrentDateForTitle = date+mon+year+"_"+
        ("0" + currentDate.getHours()).slice(-2) + 
        ("0" + currentDate.getMinutes()).slice(-2) + 
        ("0" + currentDate.getSeconds()).slice(-2);
    return defaultCurrentDateForTitle;
  }

  resetMemoriesList(){
    this.memoriesList = [];
  }
  sendMemoryAnalytics(url,payload){
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.post(url,payload).subscribe(
        suc=>{
          resolve(suc);
        },
        err=>{
          console.log("error in memory analytics",err);
          reject(err);
        }
      )
    })
  }

  updateMemoryToggle(url,updateStatus){
    var self = this;
    let isSpotlightEnabled = updateStatus?"Y":"N"
    var params = {
      "isSpotlightEnabled": isSpotlightEnabled
    }
    return new Promise(function(resolve,reject){
      self.http.put(url,params).subscribe(
        suc=>{
          resolve(true)
        },
        err=>{
          console.log('error in toggling updateMemoryToggle',err);
          self.universalService.showToast(TOAST["GENERIC_ERROR"],"error");
          reject(false);
        }
        )
    })
  }

}